<template>
    <TextFormatEditor :modelValue="modelValue"
                      :readOnly="true" />
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import { TextData } from '@/models/TextData'

    export default defineComponent({
        props: {
            modelValue: {
                type: Object as PropType<TextData>,
                required: true,
            }
        }
    });
</script>

<style lang="scss" scoped>
    :deep().ql-editor > * {
        cursor: default;
    }
</style>
